/* ===== Pagination des listes : remontee au-dessus du petit mot + copie en haut (2026-09-01, BOS) ===== */
(function(){
  function pePag(){
    var form=document.querySelector('form.giftreggie-registry-form');if(!form)return;
    var pag=form.querySelector('#pagination-div');if(!pag)return;
    if(pag.getAttribute('data-pe-pag')==='1')return;
    var anchor=form.querySelector('ul.giftreggie-mobile')||form.querySelector('table.giftreggie-view-registry');
    if(!anchor)return;
    pag.setAttribute('data-pe-pag','1');
    var top=pag.cloneNode(true);top.removeAttribute('id');top.className='pe-gr-pag-top';
    var first=form.querySelector('table.giftreggie-view-registry')||anchor;
    form.insertBefore(top,first);
    if(anchor.nextSibling){form.insertBefore(pag,anchor.nextSibling);}else{form.appendChild(pag);}
  }
  function peInitPag(){pePag();setInterval(pePag,1000);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',peInitPag);}else{peInitPag();}
})();

/* ===== Vue parent : statut lisible, « Offert par » sous chaque article, onglet « Cadeaux offerts » (2026-11-04, BOS)
   Ne touche ni au formulaire, ni aux quantités, ni au panier : les cellules d'origine restent en place, masquées. ===== */
(function(){
  function nb(el){return parseInt(((el&&el.textContent)||'').replace(/[^0-9-]/g,''),10)||0;}
  function propre(s){return String(s||'').replace(/\s+/g,' ').trim();}
  function statut(fait,reste){
    var box=document.createElement('div');box.className='pe-gr-statut';
    var pill=document.createElement('span');
    if(reste>0){
      pill.className='pe-gr-st pe-gr-st--reste';pill.textContent='Reste à offrir : '+reste;box.appendChild(pill);
      if(fait>0){var sub=document.createElement('div');sub.className='pe-gr-st-sub';sub.textContent=fait+' déjà offert'+(fait>1?'s':'');box.appendChild(sub);}
    }else if(fait>0){
      pill.className='pe-gr-st pe-gr-st--ok';pill.textContent='Déjà offert ✓';box.appendChild(pill);
    }else{
      pill.className='pe-gr-st pe-gr-st--vide';pill.textContent='Non souhaité';box.appendChild(pill);
    }
    return box;
  }
  function signature(fait,reste){return fait+'/'+reste;}
  function majTableau(t){
    var lignes=[].slice.call(t.querySelectorAll('tr'));
    lignes.forEach(function(tr,i){
      var c=tr.children;
      if(i===0){
        if(tr.getAttribute('data-pe-st')==='1'||c.length<8)return;
        tr.setAttribute('data-pe-st','1');
        c[5].style.display='none';c[6].style.display='none';
        var th=document.createElement('th');th.textContent='Statut';tr.insertBefore(th,c[7]);
        return;
      }
      var besoin=tr.querySelector('td.giftreggie-needs-quantity');if(!besoin)return;
      var cFait=besoin.previousElementSibling;
      var fait=nb(cFait),reste=nb(besoin),sig=signature(fait,reste);
      if(tr.getAttribute('data-pe-st')===sig)return;
      tr.setAttribute('data-pe-st',sig);
      cFait.style.display='none';besoin.style.display='none';
      var td=tr.querySelector('td.pe-gr-col-statut');
      if(!td){td=document.createElement('td');td.className='pe-gr-col-statut';besoin.parentNode.insertBefore(td,besoin.nextSibling);}
      td.innerHTML='';td.appendChild(statut(fait,reste));
      tr.classList.toggle('pe-gr-ligne-ok',fait>0&&reste<=0);
    });
  }
  function majCartes(front){
    [].forEach.call(front.querySelectorAll('ul.giftreggie-mobile li.registry-variant'),function(li){
      var besoin=li.querySelector('td.giftreggie-needs-quantity');if(!besoin||!li.querySelector('input[name^="want-quantity"]'))return;
      var cFait=besoin.previousElementSibling&&besoin.previousElementSibling.previousElementSibling;if(!cFait)return;
      var fait=nb(cFait),reste=nb(besoin),sig=signature(fait,reste);
      if(li.getAttribute('data-pe-st')===sig)return;
      li.setAttribute('data-pe-st',sig);
      [cFait.previousElementSibling,cFait,besoin.previousElementSibling,besoin].forEach(function(el){if(el)el.style.display='none';});
      var nom=li.querySelector('.giftreggie-item-name');var hote=nom&&(nom.closest('p')||nom.parentNode);if(!hote)return;
      var ancien=li.querySelector('.pe-gr-statut');if(ancien)ancien.parentNode.removeChild(ancien);
      hote.parentNode.insertBefore(statut(fait,reste),hote.nextSibling);
    });
  }
  var acheteurs=null,enCours=false;
  function chargerAcheteurs(id){
    if(acheteurs||enCours)return;enCours=true;
    fetch('/apps/giftregistry/registry/'+id+'/orders',{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(h){
      var doc=new DOMParser().parseFromString(h,'text/html');var res={};
      var t=doc.querySelector('table.giftreggie-orders');
      if(t){[].slice.call(t.querySelectorAll('tr')).slice(1).forEach(function(tr){
        var c=tr.children;if(c.length<7)return;
        var qui=propre(c[2].textContent),quoi=propre(c[4].textContent);if(!qui||!quoi)return;
        if(!res[quoi])res[quoi]=[];if(res[quoi].indexOf(qui)<0)res[quoi].push(qui);
      });}
      acheteurs=res;
    }).catch(function(){acheteurs={};});
  }
  function poseNoms(racine){
    if(!acheteurs)return;
    var nom=racine.querySelector('.giftreggie-item-name');if(!nom)return;
    var titre=propre(nom.textContent);if(!titre)return;
    if(racine.getAttribute('data-pe-noms')==='1')return;racine.setAttribute('data-pe-noms','1');
    var liste=acheteurs[titre];if(!liste||!liste.length)return;
    var d=document.createElement('div');d.className='pe-gr-offert';
    d.appendChild(document.createTextNode('Offert par '));
    var b=document.createElement('strong');b.textContent=liste.join(', ');d.appendChild(b);
    var st=racine.querySelector('.pe-gr-statut');
    if(racine.tagName==='LI'&&st){st.appendChild(d);}
    else{(nom.closest('td')||nom.parentNode).appendChild(d);}
  }
  function vueParent(front){
    if(!front.querySelector('input[name^="want-quantity"]'))return;
    var t=front.querySelector('table.giftreggie-view-registry');if(t)majTableau(t);
    majCartes(front);
    var m=location.pathname.match(/registry\/(\d+)/);if(m)chargerAcheteurs(m[1]);
    [].forEach.call(front.querySelectorAll('tr.registry-variant,li.registry-variant'),poseNoms);
  }
  function ongletCommandes(front){
    [].forEach.call(front.querySelectorAll('.giftreggie-header li a'),function(a){if(propre(a.textContent)==='Commandes')a.textContent='Cadeaux offerts';});
    var w=document.createTreeWalker(front,NodeFilter.SHOW_TEXT,null),n;
    while(n=w.nextNode()){if(n.textContent.trim()==='Pas de commande'){n.textContent="Aucun cadeau offert pour l'instant.";}}
    var t=front.querySelector('table.giftreggie-orders');if(!t)return;
    [].slice.call(t.querySelectorAll('tr')).forEach(function(tr,i){
      var c=tr.children;if(c.length<7)return;
      if(i===0){if(propre(c[2].textContent)==='Utilisateur')c[2].textContent='Offert par';return;}
      var p=propre(c[5].textContent);if(/^\d+\.\d{2}$/.test(p))c[5].textContent=p.replace('.',',')+' €';
    });
  }
  function peStatut(){var front=document.querySelector('.giftreggie-front');if(!front)return;vueParent(front);ongletCommandes(front);}
  function peInitStatut(){peStatut();setInterval(peStatut,800);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',peInitStatut);}else{peInitStatut();}
})();
